/* AUTO-GENERATED by packages/design-tokens. Do not edit by hand. */
// Consumed by apps/web/src/theme/system.ts (spread into the :root global styles).

export const rootCssVars: Record<string, string> = {
  '--base-brand-50': '#fff0f7',
  '--base-brand-100': '#ffd4e6',
  '--base-brand-300': '#ff77b0',
  '--base-brand-400': '#f15095',
  '--base-brand-500': '#de3f7f',
  '--base-brand-600': '#c42f6a',
  '--base-ink-50': '#f7fafc',
  '--base-ink-100': '#edf4f6',
  '--base-ink-200': '#dce8ea',
  '--base-ink-300': '#c5d9e0',
  '--base-ink-400': '#a8c4cf',
  '--base-ink-500': '#6e8089',
  '--base-ink-600': '#4e5f69',
  '--base-ink-700': '#3c4b54',
  '--base-ink-800': '#2e3941',
  '--base-ink-900': '#1f2933',
  '--base-accent-bg': '#d2e4ea',
  '--base-control-accent': '#6ba3b5',
  '--base-white': '#ffffff',
  '--base-black': '#000000',
  '--base-ink-overlay': '#0c1117',
  '--base-surface-raised': '#f9fafb',
  '--base-surface-subtle': '#f8f9fa',
  '--base-surface-muted': '#f5f5f5',
  '--base-surface-faint': '#f0f0f0',
  '--base-spinner-track': '#f3f3f3',
  '--base-divider': '#e5e7eb',
  '--base-divider-strong': '#e0e0e0',
  '--base-divider-weak': '#dddddd',
  '--base-disabled': '#cccccc',
  '--base-disabled-strong': '#999999',
  '--base-red-300': '#f87171',
  '--base-red-500': '#ef4444',
  '--base-red-600': '#dc2626',
  '--base-red-700': '#b91c1c',
  '--base-red-700b': '#d32f2f',
  '--base-red-bg': '#fef2f2',
  '--base-red-bg-mid': '#fee2e2',
  '--base-red-bg-subtle': '#fecaca',
  '--base-red-bg-legacy': '#ffeeee',
  '--base-red-border-legacy': '#ffcccc',
  '--base-amber-300': '#fbbf24',
  '--base-amber-500': '#f59e0b',
  '--base-amber-fg': '#92400e',
  '--base-amber-fg-mid': '#854d0e',
  '--base-amber-fg-badge': '#b45309',
  '--base-amber-fg-dark': '#713f12',
  '--base-amber-bg': '#fef3c7',
  '--base-amber-bg-mid': '#fef9c3',
  '--base-amber-bg-bright': '#fef08a',
  '--base-green-300': '#4ade80',
  '--base-green-500': '#10b981',
  '--base-green-bright': '#22c55e',
  '--base-green-fg': '#065f46',
  '--base-green-fg-mid': '#047857',
  '--base-green-fg-dark': '#166534',
  '--base-green-fg-badge': '#15803d',
  '--base-green-bg': '#d1fae5',
  '--base-green-bg-bright': '#dcfce7',
  '--base-blue-300': '#60a5fa',
  '--base-blue-500': '#3b82f6',
  '--base-blue-700': '#1d4ed8',
  '--base-indigo-500': '#6366f1',
  '--base-teal': '#00897b',
  '--base-teal-dark': '#00796b',
  '--base-teal-bg': '#e0f2f1',
  '--base-teal-bg-dark': '#b2dfdb',
  '--base-teal-bg-light': '#f0f9f7',
  '--base-video-stage': '#0f1419',
  '--base-video-placeholder': '#9575cd',
  '--base-admin-group-title': '#4a5b66',
  '--base-admin-divider': '#b6ccd5',
  '--base-admin-card-border': '#9ccfdf',
  '--base-admin-card-border-hover': '#75b9cf',
  '--base-admin-card-border-active': '#59afcf',
  '--base-admin-active-badge-bg': '#caedf8',
  '--base-admin-active-badge-color': '#2f88aa',
  '--base-admin-panel-bg': '#ebf5f7',
  '--base-admin-panel-border': '#bfdbe5',
  '--base-admin-chip-bg': '#f5fafb',
  '--base-admin-chip-border': '#b7d8e4',
  '--base-admin-chip-border-hover': '#7cbfd5',
  '--base-admin-chip-border-active': '#429cbf',
  '--base-electric-card-bg': '#131313',
  '--base-electric-preview-border': '#383838',
  '--base-electric-line': '#8f8f8f',
  '--base-electric-accent': '#ff6b2c',
  '--base-miami-yellow-card-bg': '#f3f0e3',
  '--base-miami-yellow-preview-border': '#d8cfab',
  '--base-miami-yellow-line': '#8b876f',
  '--base-miami-yellow-accent': '#e1b336',
  '--base-miami-yellow-card-bg-dark': '#2a220c',
  '--base-miami-yellow-preview-border-dark': '#5e4a1c',
  '--base-miami-yellow-line-dark': '#cab77b',
  '--base-miami-yellow-chip-bg': '#faf4dd',
  '--base-miami-yellow-chip-border': '#e7ca7b',
  '--base-miami-blue-card-bg': '#e3eef2',
  '--base-miami-blue-preview-border': '#bdd3dd',
  '--base-miami-blue-line': '#73858e',
  '--base-miami-blue-accent': '#5db9d9',
  '--base-miami-blue-card-bg-dark': '#122734',
  '--base-miami-blue-preview-border-dark': '#255168',
  '--base-miami-blue-line-dark': '#a6cedd',
  '--base-miami-blue-chip-bg': '#ebf7fb',
  '--base-miami-blue-chip-border': '#90cde3',
  '--base-miami-pink-card-bg': '#f4e8ef',
  '--base-miami-pink-preview-border': '#dac2d0',
  '--base-miami-pink-line': '#8a7682',
  '--base-miami-pink-accent': '#eb4f8a',
  '--base-miami-pink-card-bg-dark': '#2d1527',
  '--base-miami-pink-preview-border-dark': '#653256',
  '--base-miami-pink-line-dark': '#dab5cb',
  '--base-miami-pink-chip-bg': '#fae8f1',
  '--base-miami-pink-chip-border': '#e6a9c4',
  '--theme-background': 'var(--base-ink-200)',
  '--theme-card-background': 'var(--base-ink-100)',
  '--theme-accent-background': 'var(--base-accent-bg)',
  '--theme-accent-border': 'var(--base-ink-400)',
  '--input-focus-border': 'var(--base-control-accent)',
  '--input-focus-ring': 'rgba(107, 163, 181, 0.3)',
  '--theme-text-color': 'var(--base-ink-900)',
  '--theme-text-color-secondary': 'var(--base-ink-600)',
  '--theme-text-color-muted': 'var(--base-ink-600)',
  '--theme-text-color-strong': 'var(--base-ink-700)',
  '--action-primary-background': 'var(--base-ink-900)',
  '--action-primary-background-hover': 'var(--base-ink-800)',
  '--action-primary-foreground': 'var(--base-white)',
  '--action-secondary-background': 'var(--base-accent-bg)',
  '--action-secondary-background-hover': 'var(--base-ink-300)',
  '--action-secondary-foreground': 'var(--base-ink-900)',
  '--control-border': 'var(--base-ink-500)',
  '--control-border-hover': 'var(--base-ink-700)',
  '--control-border-disabled': 'var(--base-ink-300)',
  '--coach-accent': 'var(--base-brand-600)',
  '--coach-accent-strong': 'var(--base-brand-600)',
  '--coach-accent-subtle': 'var(--base-brand-50)',
  '--coach-accent-border': 'var(--base-brand-300)',
  '--coach-accent-15': 'rgba(241, 80, 149, 0.15)',
  '--coach-accent-30': 'rgba(241, 80, 149, 0.3)',
  '--coach-accent-40': 'rgba(241, 80, 149, 0.4)',
  '--color-white': 'var(--base-white)',
  '--color-black': 'var(--base-black)',
  '--overlay-white-20': 'rgba(255, 255, 255, 0.2)',
  '--overlay-light': 'rgba(0, 0, 0, 0.04)',
  '--overlay-sm': 'rgba(0, 0, 0, 0.1)',
  '--overlay-md': 'rgba(0, 0, 0, 0.3)',
  '--overlay-dark': 'rgba(0, 0, 0, 0.5)',
  '--overlay-darker': 'rgba(0, 0, 0, 0.7)',
  '--overlay-ink-55': 'rgba(12, 17, 23, 0.55)',
  '--overlay-ink-72': 'rgba(12, 17, 23, 0.72)',
  '--surface-raised': 'var(--base-surface-raised)',
  '--surface-subtle': 'var(--base-surface-subtle)',
  '--surface-muted': 'var(--base-surface-muted)',
  '--surface-faint': 'var(--base-surface-faint)',
  '--surface-divider': 'var(--base-divider)',
  '--surface-divider-strong': 'var(--base-divider-strong)',
  '--surface-divider-weak': 'var(--base-divider-weak)',
  '--surface-disabled': 'var(--base-disabled)',
  '--surface-disabled-strong': 'var(--base-disabled-strong)',
  '--error-solid': 'var(--base-red-600)',
  '--error-fg': 'var(--base-red-700)',
  '--error-fg-dark': 'var(--base-red-700b)',
  '--error-bg': 'var(--base-red-bg)',
  '--error-bg-mid': 'var(--base-red-bg-mid)',
  '--error-bg-subtle': 'var(--base-red-bg-subtle)',
  '--error-bg-translucent': 'rgba(239, 68, 68, 0.14)',
  '--error-bg-translucent-hover': 'rgba(239, 68, 68, 0.2)',
  '--error-bg-legacy': 'var(--base-red-bg-legacy)',
  '--error-border-legacy': 'var(--base-red-border-legacy)',
  '--error-shadow': 'rgba(220, 38, 38, 0.3)',
  '--error-shadow-sm': 'rgba(220, 38, 38, 0.1)',
  '--warning-solid': 'var(--base-amber-500)',
  '--warning-fg': 'var(--base-amber-fg)',
  '--warning-fg-mid': 'var(--base-amber-fg-mid)',
  '--warning-fg-badge': 'var(--base-amber-fg-badge)',
  '--warning-fg-dark': 'var(--base-amber-fg-dark)',
  '--warning-bg': 'var(--base-amber-bg)',
  '--warning-bg-mid': 'var(--base-amber-bg-mid)',
  '--warning-bg-bright': 'var(--base-amber-bg-bright)',
  '--warning-bg-translucent': 'rgba(245, 158, 11, 0.18)',
  '--success-solid': 'var(--base-green-500)',
  '--success-solid-bright': 'var(--base-green-bright)',
  '--success-fg': 'var(--base-green-fg)',
  '--success-fg-mid': 'var(--base-green-fg-mid)',
  '--success-fg-dark': 'var(--base-green-fg-dark)',
  '--success-fg-badge': 'var(--base-green-fg-badge)',
  '--success-bg': 'var(--base-green-bg)',
  '--success-bg-bright': 'var(--base-green-bg-bright)',
  '--success-bg-translucent': 'rgba(34, 197, 94, 0.15)',
  '--info-bg-translucent': 'rgba(59, 130, 246, 0.14)',
  '--info-fg': 'var(--base-blue-700)',
  '--status-active-bg': 'rgba(34, 197, 94, 0.15)',
  '--status-active-fg': 'var(--base-green-300)',
  '--status-error-bg': 'rgba(239, 68, 68, 0.12)',
  '--status-error-fg': 'var(--base-red-300)',
  '--status-warning-bg': 'rgba(251, 191, 36, 0.15)',
  '--status-warning-fg': 'var(--base-amber-300)',
  '--status-info-bg': 'rgba(96, 165, 250, 0.15)',
  '--status-info-fg': 'var(--base-blue-300)',
  '--radius': '20px',
  '--radius-sm': '12px',
  '--shadow-sm': '0 4px 16px rgba(12, 17, 23, 0.12)',
  '--shadow-md': '0 12px 24px rgba(12, 17, 23, 0.12)',
  '--shadow-lg': '0 18px 40px rgba(12, 17, 23, 0.18)',
  '--shadow-sheet': '0 -12px 30px rgba(12, 17, 23, 0.18)',
  '--color-video-stage': 'var(--base-video-stage)',
  '--color-video-thumbnail-placeholder': 'var(--base-video-placeholder)',
  '--color-spinner-track': 'var(--base-spinner-track)',
  '--color-teal': 'var(--base-teal)',
  '--color-teal-dark': 'var(--base-teal-dark)',
  '--color-teal-bg': 'var(--base-teal-bg)',
  '--color-teal-bg-dark': 'var(--base-teal-bg-dark)',
  '--color-teal-bg-light': 'var(--base-teal-bg-light)',
  '--color-indigo': 'var(--base-indigo-500)',
  '--admin-settings-group-title-color': 'var(--base-admin-group-title)',
  '--admin-settings-divider': 'var(--base-admin-divider)',
  '--admin-theme-card-border': 'var(--base-admin-card-border)',
  '--admin-theme-card-border-hover': 'var(--base-admin-card-border-hover)',
  '--admin-theme-card-border-active': 'var(--base-admin-card-border-active)',
  '--admin-theme-active-badge-background': 'var(--base-admin-active-badge-bg)',
  '--admin-theme-active-badge-color': 'var(--base-admin-active-badge-color)',
  '--admin-secondary-panel-background': 'var(--base-admin-panel-bg)',
  '--admin-secondary-panel-border': 'var(--base-admin-panel-border)',
  '--admin-secondary-chip-border-hover': 'var(--base-admin-chip-border-hover)',
  '--admin-secondary-chip-border-active': 'var(--base-admin-chip-border-active)',
  '--admin-secondary-chip-background': 'var(--base-admin-chip-bg)',
  '--admin-secondary-chip-border': 'var(--base-admin-chip-border)',
  '--admin-electric-card-background': 'var(--base-electric-card-bg)',
  '--admin-electric-preview-border': 'var(--base-electric-preview-border)',
  '--admin-electric-line-color': 'var(--base-electric-line)',
  '--admin-electric-accent': 'var(--base-electric-accent)',
  '--admin-miami-yellow-card-background': 'var(--base-miami-yellow-card-bg)',
  '--admin-miami-yellow-preview-border': 'var(--base-miami-yellow-preview-border)',
  '--admin-miami-yellow-line-color': 'var(--base-miami-yellow-line)',
  '--admin-miami-yellow-accent': 'var(--base-miami-yellow-accent)',
  '--admin-miami-yellow-card-background-dark': 'var(--base-miami-yellow-card-bg-dark)',
  '--admin-miami-yellow-preview-border-dark': 'var(--base-miami-yellow-preview-border-dark)',
  '--admin-miami-yellow-line-color-dark': 'var(--base-miami-yellow-line-dark)',
  '--admin-miami-yellow-secondary-chip-background': 'var(--base-miami-yellow-chip-bg)',
  '--admin-miami-yellow-secondary-chip-border': 'var(--base-miami-yellow-chip-border)',
  '--admin-miami-blue-card-background': 'var(--base-miami-blue-card-bg)',
  '--admin-miami-blue-preview-border': 'var(--base-miami-blue-preview-border)',
  '--admin-miami-blue-line-color': 'var(--base-miami-blue-line)',
  '--admin-miami-blue-accent': 'var(--base-miami-blue-accent)',
  '--admin-miami-blue-card-background-dark': 'var(--base-miami-blue-card-bg-dark)',
  '--admin-miami-blue-preview-border-dark': 'var(--base-miami-blue-preview-border-dark)',
  '--admin-miami-blue-line-color-dark': 'var(--base-miami-blue-line-dark)',
  '--admin-miami-blue-secondary-chip-background': 'var(--base-miami-blue-chip-bg)',
  '--admin-miami-blue-secondary-chip-border': 'var(--base-miami-blue-chip-border)',
  '--admin-miami-pink-card-background': 'var(--base-miami-pink-card-bg)',
  '--admin-miami-pink-preview-border': 'var(--base-miami-pink-preview-border)',
  '--admin-miami-pink-line-color': 'var(--base-miami-pink-line)',
  '--admin-miami-pink-accent': 'var(--base-miami-pink-accent)',
  '--admin-miami-pink-card-background-dark': 'var(--base-miami-pink-card-bg-dark)',
  '--admin-miami-pink-preview-border-dark': 'var(--base-miami-pink-preview-border-dark)',
  '--admin-miami-pink-line-color-dark': 'var(--base-miami-pink-line-dark)',
  '--admin-miami-pink-secondary-chip-background': 'var(--base-miami-pink-chip-bg)',
  '--admin-miami-pink-secondary-chip-border': 'var(--base-miami-pink-chip-border)',
}

/** Public, consumer-facing color token CSS var names (excludes private --base-* and non-color tokens). */
export const publicColorTokenNames: readonly string[] = [
  "--theme-background",
  "--theme-card-background",
  "--theme-accent-background",
  "--theme-accent-border",
  "--input-focus-border",
  "--input-focus-ring",
  "--theme-text-color",
  "--theme-text-color-secondary",
  "--theme-text-color-muted",
  "--theme-text-color-strong",
  "--action-primary-background",
  "--action-primary-background-hover",
  "--action-primary-foreground",
  "--action-secondary-background",
  "--action-secondary-background-hover",
  "--action-secondary-foreground",
  "--control-border",
  "--control-border-hover",
  "--control-border-disabled",
  "--coach-accent",
  "--coach-accent-strong",
  "--coach-accent-subtle",
  "--coach-accent-border",
  "--coach-accent-15",
  "--coach-accent-30",
  "--coach-accent-40",
  "--color-white",
  "--color-black",
  "--overlay-white-20",
  "--overlay-light",
  "--overlay-sm",
  "--overlay-md",
  "--overlay-dark",
  "--overlay-darker",
  "--overlay-ink-55",
  "--overlay-ink-72",
  "--surface-raised",
  "--surface-subtle",
  "--surface-muted",
  "--surface-faint",
  "--surface-divider",
  "--surface-divider-strong",
  "--surface-divider-weak",
  "--surface-disabled",
  "--surface-disabled-strong",
  "--error-solid",
  "--error-fg",
  "--error-fg-dark",
  "--error-bg",
  "--error-bg-mid",
  "--error-bg-subtle",
  "--error-bg-translucent",
  "--error-bg-translucent-hover",
  "--error-bg-legacy",
  "--error-border-legacy",
  "--error-shadow",
  "--error-shadow-sm",
  "--warning-solid",
  "--warning-fg",
  "--warning-fg-mid",
  "--warning-fg-badge",
  "--warning-fg-dark",
  "--warning-bg",
  "--warning-bg-mid",
  "--warning-bg-bright",
  "--warning-bg-translucent",
  "--success-solid",
  "--success-solid-bright",
  "--success-fg",
  "--success-fg-mid",
  "--success-fg-dark",
  "--success-fg-badge",
  "--success-bg",
  "--success-bg-bright",
  "--success-bg-translucent",
  "--info-bg-translucent",
  "--info-fg",
  "--status-active-bg",
  "--status-active-fg",
  "--status-error-bg",
  "--status-error-fg",
  "--status-warning-bg",
  "--status-warning-fg",
  "--status-info-bg",
  "--status-info-fg",
  "--shadow-sm",
  "--shadow-md",
  "--shadow-lg",
  "--shadow-sheet",
  "--color-video-stage",
  "--color-video-thumbnail-placeholder",
  "--color-spinner-track",
  "--color-teal",
  "--color-teal-dark",
  "--color-teal-bg",
  "--color-teal-bg-dark",
  "--color-teal-bg-light",
  "--color-indigo",
  "--admin-settings-group-title-color",
  "--admin-settings-divider",
  "--admin-theme-card-border",
  "--admin-theme-card-border-hover",
  "--admin-theme-card-border-active",
  "--admin-theme-active-badge-background",
  "--admin-theme-active-badge-color",
  "--admin-secondary-panel-background",
  "--admin-secondary-panel-border",
  "--admin-secondary-chip-border-hover",
  "--admin-secondary-chip-border-active",
  "--admin-secondary-chip-background",
  "--admin-secondary-chip-border",
  "--admin-electric-card-background",
  "--admin-electric-preview-border",
  "--admin-electric-line-color",
  "--admin-electric-accent",
  "--admin-miami-yellow-card-background",
  "--admin-miami-yellow-preview-border",
  "--admin-miami-yellow-line-color",
  "--admin-miami-yellow-accent",
  "--admin-miami-yellow-card-background-dark",
  "--admin-miami-yellow-preview-border-dark",
  "--admin-miami-yellow-line-color-dark",
  "--admin-miami-yellow-secondary-chip-background",
  "--admin-miami-yellow-secondary-chip-border",
  "--admin-miami-blue-card-background",
  "--admin-miami-blue-preview-border",
  "--admin-miami-blue-line-color",
  "--admin-miami-blue-accent",
  "--admin-miami-blue-card-background-dark",
  "--admin-miami-blue-preview-border-dark",
  "--admin-miami-blue-line-color-dark",
  "--admin-miami-blue-secondary-chip-background",
  "--admin-miami-blue-secondary-chip-border",
  "--admin-miami-pink-card-background",
  "--admin-miami-pink-preview-border",
  "--admin-miami-pink-line-color",
  "--admin-miami-pink-accent",
  "--admin-miami-pink-card-background-dark",
  "--admin-miami-pink-preview-border-dark",
  "--admin-miami-pink-line-color-dark",
  "--admin-miami-pink-secondary-chip-background",
  "--admin-miami-pink-secondary-chip-border"
]

/** All public role token CSS var names (color + dimension). */
export const publicTokenNames: readonly string[] = [
  "--theme-background",
  "--theme-card-background",
  "--theme-accent-background",
  "--theme-accent-border",
  "--input-focus-border",
  "--input-focus-ring",
  "--theme-text-color",
  "--theme-text-color-secondary",
  "--theme-text-color-muted",
  "--theme-text-color-strong",
  "--action-primary-background",
  "--action-primary-background-hover",
  "--action-primary-foreground",
  "--action-secondary-background",
  "--action-secondary-background-hover",
  "--action-secondary-foreground",
  "--control-border",
  "--control-border-hover",
  "--control-border-disabled",
  "--coach-accent",
  "--coach-accent-strong",
  "--coach-accent-subtle",
  "--coach-accent-border",
  "--coach-accent-15",
  "--coach-accent-30",
  "--coach-accent-40",
  "--color-white",
  "--color-black",
  "--overlay-white-20",
  "--overlay-light",
  "--overlay-sm",
  "--overlay-md",
  "--overlay-dark",
  "--overlay-darker",
  "--overlay-ink-55",
  "--overlay-ink-72",
  "--surface-raised",
  "--surface-subtle",
  "--surface-muted",
  "--surface-faint",
  "--surface-divider",
  "--surface-divider-strong",
  "--surface-divider-weak",
  "--surface-disabled",
  "--surface-disabled-strong",
  "--error-solid",
  "--error-fg",
  "--error-fg-dark",
  "--error-bg",
  "--error-bg-mid",
  "--error-bg-subtle",
  "--error-bg-translucent",
  "--error-bg-translucent-hover",
  "--error-bg-legacy",
  "--error-border-legacy",
  "--error-shadow",
  "--error-shadow-sm",
  "--warning-solid",
  "--warning-fg",
  "--warning-fg-mid",
  "--warning-fg-badge",
  "--warning-fg-dark",
  "--warning-bg",
  "--warning-bg-mid",
  "--warning-bg-bright",
  "--warning-bg-translucent",
  "--success-solid",
  "--success-solid-bright",
  "--success-fg",
  "--success-fg-mid",
  "--success-fg-dark",
  "--success-fg-badge",
  "--success-bg",
  "--success-bg-bright",
  "--success-bg-translucent",
  "--info-bg-translucent",
  "--info-fg",
  "--status-active-bg",
  "--status-active-fg",
  "--status-error-bg",
  "--status-error-fg",
  "--status-warning-bg",
  "--status-warning-fg",
  "--status-info-bg",
  "--status-info-fg",
  "--radius",
  "--radius-sm",
  "--shadow-sm",
  "--shadow-md",
  "--shadow-lg",
  "--shadow-sheet",
  "--color-video-stage",
  "--color-video-thumbnail-placeholder",
  "--color-spinner-track",
  "--color-teal",
  "--color-teal-dark",
  "--color-teal-bg",
  "--color-teal-bg-dark",
  "--color-teal-bg-light",
  "--color-indigo",
  "--admin-settings-group-title-color",
  "--admin-settings-divider",
  "--admin-theme-card-border",
  "--admin-theme-card-border-hover",
  "--admin-theme-card-border-active",
  "--admin-theme-active-badge-background",
  "--admin-theme-active-badge-color",
  "--admin-secondary-panel-background",
  "--admin-secondary-panel-border",
  "--admin-secondary-chip-border-hover",
  "--admin-secondary-chip-border-active",
  "--admin-secondary-chip-background",
  "--admin-secondary-chip-border",
  "--admin-electric-card-background",
  "--admin-electric-preview-border",
  "--admin-electric-line-color",
  "--admin-electric-accent",
  "--admin-miami-yellow-card-background",
  "--admin-miami-yellow-preview-border",
  "--admin-miami-yellow-line-color",
  "--admin-miami-yellow-accent",
  "--admin-miami-yellow-card-background-dark",
  "--admin-miami-yellow-preview-border-dark",
  "--admin-miami-yellow-line-color-dark",
  "--admin-miami-yellow-secondary-chip-background",
  "--admin-miami-yellow-secondary-chip-border",
  "--admin-miami-blue-card-background",
  "--admin-miami-blue-preview-border",
  "--admin-miami-blue-line-color",
  "--admin-miami-blue-accent",
  "--admin-miami-blue-card-background-dark",
  "--admin-miami-blue-preview-border-dark",
  "--admin-miami-blue-line-color-dark",
  "--admin-miami-blue-secondary-chip-background",
  "--admin-miami-blue-secondary-chip-border",
  "--admin-miami-pink-card-background",
  "--admin-miami-pink-preview-border",
  "--admin-miami-pink-line-color",
  "--admin-miami-pink-accent",
  "--admin-miami-pink-card-background-dark",
  "--admin-miami-pink-preview-border-dark",
  "--admin-miami-pink-line-color-dark",
  "--admin-miami-pink-secondary-chip-background",
  "--admin-miami-pink-secondary-chip-border"
]
